import { paperClasses } from '@mui/material';

export function createComponents() {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          [`&.${paperClasses.elevation1}`]: {
            boxShadow:
              '0px 5px 22px rgba(0, 0, 0, 0.04), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.03)',
          },
          borderRadius: 20,
        },
      },
    },
  };
}
